import { getAcquisitionFormScriptUrl } from './loadConfig.js';

const scriptUrl = getAcquisitionFormScriptUrl();

function importSibling(fileName) {
  return import(/* @vite-ignore */ new URL(fileName, scriptUrl || window.location.href).href);
}

export const loadPhoneUtils = __WIDGET_DEV_SERVER__
  ? () => import('intl-tel-input/utils')
  : () => importSibling('iti-utils.js');

let cardCrypto = null;

export function loadCardCrypto() {
  cardCrypto ??= (__WIDGET_DEV_SERVER__
    ? import('./paymentCrypto.js')
    : importSibling('card-crypto.js')
  ).catch((error) => {
    cardCrypto = null;
    throw error;
  });
  return cardCrypto;
}
